import { render, staticRenderFns } from "./ApprovalDocumentCompany.vue?vue&type=template&id=7c5cc546&scoped=true"
import script from "./ApprovalDocumentCompany.vue?vue&type=script&lang=js"
export * from "./ApprovalDocumentCompany.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDocumentCompany.vue?vue&type=style&index=0&id=7c5cc546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5cc546",
  null
  
)

export default component.exports